import React from 'react';
import { LifeBuoy } from 'lucide-react';
import {
  REPORT_ISSUE_CONTEXTUAL_LINK_LABEL,
  REPORT_ISSUE_GLOBAL_LINK_LABEL,
} from '../../supportIssueCopy';
import { useReportIssueOptional, type ReportIssuePrefill } from './ReportIssueContext';
import ReportIssueModal from './ReportIssueModal';

interface ReportIssueTriggerProps {
  prefill?: ReportIssuePrefill;
  variant?: 'link' | 'nav' | 'inline';
  className?: string;
  testId?: string;
  children?: React.ReactNode;
}

export function ReportIssueTrigger({
  prefill,
  variant = 'link',
  className,
  testId = 'report-issue-trigger',
  children,
}: ReportIssueTriggerProps) {
  const ctx = useReportIssueOptional();
  if (!ctx) return null;

  const label =
    children ??
    (variant === 'inline' ? REPORT_ISSUE_CONTEXTUAL_LINK_LABEL : REPORT_ISSUE_GLOBAL_LINK_LABEL);

  const handleClick = () => {
    ctx.openReportIssue(prefill);
  };

  if (variant === 'nav') {
    return (
      <button
        type="button"
        onClick={handleClick}
        className={
          className ??
          'flex w-full items-center gap-2 rounded-lg px-3 py-2 text-sm text-secondary-300 hover:bg-secondary-800 hover:text-white transition-colors'
        }
        data-testid={testId}
      >
        <LifeBuoy className="h-4 w-4 shrink-0" aria-hidden />
        {label}
      </button>
    );
  }

  return (
    <button
      type="button"
      onClick={handleClick}
      className={
        className ??
        'text-sm text-primary-300 hover:text-primary-200 underline-offset-2 hover:underline'
      }
      data-testid={testId}
    >
      {label}
    </button>
  );
}

export function ReportIssueShell() {
  const ctx = useReportIssueOptional();
  if (!ctx) return null;
  return (
    <ReportIssueModal open={ctx.isOpen} prefill={ctx.prefill} onClose={ctx.closeReportIssue} />
  );
}

export default ReportIssueTrigger;
